
import Utils from '~/assets/utils.js'
import DynamicMarkdown from '~/components/DynamicMarkdown.vue'
import Head from '~/assets/head.js'

export default {
  components: {
    DynamicMarkdown
  },
  mixins: [Head.titleMixin],
  props: {
    routePath: {
      default: '',
      type: String
    },
    pageContent: {
      default () {},
      type: Object
    },
    postsList: {
      default: () => [],
      type: Array
    },
    postsPrevNext: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      content: this.pageContent,
      domain: Utils.domain,
      canonicalURL: `${Utils.domain}${this.routePath}`,
      title: this.pageContent.post_title || this.pageContent.project_title,
      sharingImage: `${Utils.domain}${this.pageContent.hero.substr(2)}`,
      description: `${this.pageContent.project_desc || this.pageContent.excerpt_desc || ''}`,
      commentsEnabled: !this.pageContent.no_comments && (!this.pageContent.unlisted_post || this.pageContent.project_link)
    }
  },
  methods: {
    prettifyDate (date) {
      return Utils.prettifyDate(date)
    },
    externalLink (linkURL) {
      window.open(linkURL, '_blank') // to open in new tab
    }
  }
}
